import React, { useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Economia from "./pages/Economia";
import Trabajo from "./pages/Trabajo";
import Salud from "./pages/Salud";
import Migracion from "./pages/Migracion";
import Seguridad from "./pages/Seguridad";
import Contacto from "./pages/Contacto";
import { precargarSeries } from "./services/bancoCentral";

/* Al cambiar de ruta, vuelve arriba sin animar (el smooth global
   haría "viajar" la página completa en cada navegación). */
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

export default function App() {
  /* Las series del Banco Central se piden apenas arranca la app y quedan en
     caché: entrar a Economía las encuentra listas en vez de dispararlas de
     nuevo cada vez. Salen encoladas, de a una, así que no compiten con la
     carga inicial de la página. */
  useEffect(() => { precargarSeries(); }, []);

  return (
    <>
      <a className="skip-link" href="#contenido">
        Saltar al contenido
      </a>
      <ScrollToTop />
      <Navbar />
      <main id="contenido">
        <Routes>
          <Route path="/"          element={<Home />} />
          <Route path="/economia"  element={<Economia />} />
          <Route path="/trabajo"   element={<Trabajo />} />
          <Route path="/salud"     element={<Salud />} />
          <Route path="/migracion" element={<Migracion />} />
          <Route path="/seguridad" element={<Seguridad />} />
          <Route path="/contacto"  element={<Contacto />} />
        </Routes>
      </main>
      <Footer />
    </>
  );
}
